export default {
	addToast: 'ADD_TOAST',
	removeToast: 'REMOVE_TOAST',
};
